import React from "react";
import { useAuth } from "@/lib/auth";

export default function ImpersonationBanner() {
  const { user, exitImpersonation } = useAuth() || {};
  if (!user?.impersonation) return null;
  return (
    <div
      data-testid="impersonation-banner"
      className="sticky top-0 z-[200] bg-amber-400 text-zinc-900 px-4 py-2 flex flex-wrap items-center justify-between gap-2 text-sm"
    >
      <span>
        <strong>Supporto Velta</strong>
        {" · "}
        {user.impersonated_tenant_name || "cliente"}
        {" · collegato come titolare "}
        ({user.email})
        {user.impersonated_by_email ? ` · da ${user.impersonated_by_email}` : ""}
      </span>
      <button
        type="button"
        data-testid="impersonation-exit"
        onClick={() => exitImpersonation?.()}
        className="h-8 px-3 rounded-md bg-zinc-900 text-white text-xs font-medium hover:bg-zinc-800"
      >
        Torna al pannello Velta
      </button>
    </div>
  );
}
